/* eslint-disable @typescript-eslint/no-unused-expressions */
import { datatype, filtertype, metricFunction, BenchmarkingIndexValues } from 'API';
import { DarkButton } from 'components/style/Global';
import React, { useContext, useEffect, useState } from 'react';
import Switch from 'react-switch';
import styled from 'styled-components';
import { Container, FilterDrop, HeadModul, ModulContainer } from './TableStyles';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { AiOutlineDelete } from 'react-icons/ai';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { IoMdClose } from 'react-icons/io';

import Select from 'react-select';
import { useCampaignContext } from 'context/CampaignContext';
import InputContext from 'context/InputContext';
import { placeholderFullSources } from 'components/NewPortal/CustomReports/CustomReportQuery';
import { useCustomReportContext } from 'context/CustomReportContext';

export const Modal = styled.div`
  position: fixed; /* Stay in place */
  /* z-index: 1; Sit on top */
  z-index: 9999999;
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  display: flex;
  justify-content: center;
  align-items: center;

  .wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.4vw;
  }

  .errorInputs {
    color: red;
  }

  .containerModal {
    margin-bottom: 3rem;
  }

  /* DatePicker Styles */
  .date-picker-input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
    font-family: inherit;
    background: white;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }

    &::placeholder {
      color: #999;
    }
  }

  /* Custom DatePicker calendar styles */
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  /* Fix for month navigation arrows overlapping month name */
  .react-datepicker__header {
    background-color: #f0f0f0;
    border-bottom: 1px solid #aeaeae;
    border-radius: 0.3rem 0.3rem 0 0;
    padding: 8px 0;
    position: relative;
  }

  .react-datepicker__current-month {
    font-size: 0.944rem;
    font-weight: bold;
    color: #000;
    margin: 0;
    text-align: center;
    padding: 0 40px; /* Add padding to prevent overlap with navigation arrows */
  }

  .react-datepicker__navigation {
    position: absolute;
    /* top: 10px; */
    width: 25px;
    /* border: 6px solid red; */
    cursor: pointer;
    z-index: 1;
  }

  .react-datepicker__navigation--previous {
    left: 10px;
    border-right-color: #ccc;
  }

  .react-datepicker__navigation--next {
    right: 10px;
    border-left-color: #ccc;
  }

  .react-datepicker__navigation:hover {
    .react-datepicker__navigation--previous {
      border-right-color: #b3b3b3;
    }
    .react-datepicker__navigation--next {
      border-left-color: #b3b3b3;
    }
  }
`;

export interface Props {
  hidden: any;
  openClose(value: any): any;
  activeObject: any;
  clickedHeader: any;
  data: any;
  currentQuery: any;
  currentQueryCOPY: any;
  setCurrentQueryCOPY(data: any): any;
  testObject: any;
  mainReference: any;
  currentConversionsQueryCOPY: any;
  currentConversionsQuery: any;
  conversionsData: any;
  setChartMetrics?(chartMetric: any): any;
  chartMetrics?: any;
  currentBenchmarkQueryCOPY?: any;
  setCurrentBenchmarkQueryCOPY?(data: any): any;
  selectedDataSource?: placeholderFullSources | undefined;
  benchmarkIndex?: BenchmarkingIndexValues | null;
  setBenchmarkIndex?: (value: BenchmarkingIndexValues | null) => void;
  hideTotal?: boolean;
  setHideTotal?: (value: boolean) => void;
}

const PreviewModal = (props: Props) => {
  // console.log(props.conversionsData, "conversionsData")

  const { activeCampaign: classicCampaign } = useCampaignContext();
  const { transformedACDetailsReport } = useCustomReportContext();
  const activeCampaign = classicCampaign || transformedACDetailsReport;

  const filterOptions = props.data
    .map((element: any) => ({
      label: element[props.clickedHeader],
      value: element[props.clickedHeader],
    }))
    .filter(
      (option: any, index: number, self: any[]) => index === self.findIndex((item: any) => item.label === option.label),
    );
  console.log('FILTEROPTIONS', filterOptions);

  const [checked, setChecked] = useState(props.activeObject.hidden);
  const [checked2, setChecked2] = useState<boolean>(
    props.currentQuery.query.calculatedMetrics.some(
      (calMet: any) => calMet.query === `SUM(#cost)/SUM(#${props.activeObject.column})`,
    ),
  );
  const [checked3, setChecked3] = useState(props.activeObject.active);
  const [checked4, setChecked4] = useState<boolean>(
    props.currentQueryCOPY.query.calculatedMetrics.some((element: any) => element.name === props.activeObject.name),
  );
  console.log('CHECK', props.currentConversionsQueryCOPY);
  const [checked5, setChecked5] = useState<boolean>(() => {
    if (
      !props.currentConversionsQueryCOPY?.query?.calculatedMetrics ||
      !props.currentConversionsQueryCOPY?.views?.[0]?.viewName
    ) {
      return false; // Default value when data is not available
    }

    return props.currentConversionsQueryCOPY.query.calculatedMetrics.some((calcMetric: any) => {
      if (props.currentConversionsQueryCOPY.views[0].viewName.includes('facebook')) {
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#custom_conversions_value)';
      } else if (props.currentConversionsQueryCOPY.views[0].viewName.includes('adform')) {
        console.log('CHECK', calcMetric.query === 'SUM(#conversions_cost)/SUM(#custom_conversions)', calcMetric.query);
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#custom_conversions)';
      } else if (props.currentConversionsQueryCOPY.views[0].viewName.includes('dv360')) {
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#total_conversions)';
      } else {
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#total_conversions)';
      }
    });
  });

  const [filterToggle, setisFilterToggle] = useState(true);
  const [filterValue, setFilterValue] = useState<string | null>();
  const [filterList, setFilterList] = useState<Array<any> | null>();
  const [filterType, setFilterType] = useState<any>('IN');
  const [filterStatus, setFilterStatus] = useState<boolean>();
  const [oldName, setOldName] = useState<string>('');
  const [newName, setNewName] = useState<string>('');

  // Metric filter state variables
  const [metricFilterToggle, setMetricFilterToggle] = useState(true);
  const [metricFilterValue, setMetricFilterValue] = useState<string>('');
  const [metricFilterType, setMetricFilterType] = useState<any>(filtertype.EQUAL);

  // Benchmark state variables
  const [benchmarkOption, setBenchmarkOption] = useState<string>('');
  const [benchmarkStartDate, setBenchmarkStartDate] = useState<Date | null>(null);
  const [benchmarkEndDate, setBenchmarkEndDate] = useState<Date | null>(null);
  const [isBenchmarkEnabled, setIsBenchmarkEnabled] = useState<boolean>(false);
  const [showBenchmarkRemovalConfirmation, setShowBenchmarkRemovalConfirmation] = useState<boolean>(false);
  const [pendingFilterData, setPendingFilterData] = useState<any>(null);

  // Benchmark Index state (local state for UI, saved to parent on apply)
  const [localBenchmarkIndex, setLocalBenchmarkIndex] = useState<BenchmarkingIndexValues | null>(
    props.benchmarkIndex || null,
  );

  // Calculate maximum end date as one day before activeCampaign.startDate
  const maxBenchmarkEndDate = React.useMemo(() => {
    return activeCampaign?.startDate
      ? new Date(new Date(activeCampaign.startDate).getTime() - 24 * 60 * 60 * 1000)
      : null;
  }, [activeCampaign?.startDate]);

  // Initialize benchmarkEndDate with maxBenchmarkEndDate
  React.useEffect(() => {
    if (maxBenchmarkEndDate && !benchmarkEndDate) {
      setBenchmarkEndDate(maxBenchmarkEndDate);
    }
  }, [maxBenchmarkEndDate, benchmarkEndDate]);

  // Predefined date range functions
  const getPredefinedDateRanges = React.useMemo(() => {
    if (!maxBenchmarkEndDate) return {};

    const currentYear = maxBenchmarkEndDate.getFullYear();
    const previousYear = currentYear - 1;

    // Current year: from Jan 1 to maxBenchmarkEndDate
    const currentYearStart = new Date(currentYear, 0, 1); // Jan 1st of current year

    // Previous year: from Jan 1 to Dec 31 of previous year
    const previousYearStart = new Date(previousYear, 0, 1);
    const previousYearEnd = new Date(previousYear, 11, 31); // Dec 31st of previous year

    // Last 12 months: from (maxBenchmarkEndDate - 1 year) to maxBenchmarkEndDate
    const last12MonthsStart = new Date(maxBenchmarkEndDate.getTime() - 365 * 24 * 60 * 60 * 1000);

    return {
      currentYear: {
        label: 'Current Year',
        start: currentYearStart,
        end: maxBenchmarkEndDate,
      },
      last12Months: {
        label: 'Last 12 Months',
        start: last12MonthsStart,
        end: maxBenchmarkEndDate,
      },
      previousYear: {
        label: previousYear.toString(),
        start: previousYearStart,
        end: previousYearEnd,
      },
    };
  }, [maxBenchmarkEndDate]);

  const setPredefinedDateRange = (rangeKey: string) => {
    const range = getPredefinedDateRanges[rangeKey as keyof typeof getPredefinedDateRanges];
    if (range) {
      setBenchmarkStartDate(range.start);
      setBenchmarkEndDate(range.end);
      setBenchmarkOption('historic_data');
    }
  };

  // Use ref to track if benchmark has been initialized to avoid infinite loops
  const benchmarkInitializedRef = React.useRef<boolean>(false);

  // Reset benchmark initialization when activeObject changes
  React.useEffect(() => {
    benchmarkInitializedRef.current = false;
  }, [props.activeObject.name]);

  // Initialize benchmark options from existing benchmark query
  React.useEffect(() => {
    // Reset initialization flag when modal opens
    if (props.hidden && benchmarkInitializedRef.current) {
      benchmarkInitializedRef.current = false;
    }

    if (props.currentBenchmarkQueryCOPY && props.hidden && !benchmarkInitializedRef.current) {
      // Check if benchmark query has a date filter (indicating it's a historic data benchmark)
      const dateFilter = props.currentBenchmarkQueryCOPY.query.filters?.find((filter: any) => filter.column === 'date');

      if (dateFilter) {
        setBenchmarkOption('historic_data');

        if (dateFilter.filter?.from) {
          const newDate = new Date(dateFilter.filter.from);
          setBenchmarkStartDate(newDate);
        }

        if (dateFilter.filter?.to) {
          const newEndDate = new Date(dateFilter.filter.to);
          setBenchmarkEndDate(newEndDate);
        }

        // Check if current calculated metric is in the benchmark query
        const isCurrentMetricBenchmarked = props.currentBenchmarkQueryCOPY.query.calculatedMetrics?.some(
          (calc: any) => calc.query === props.activeObject.query,
        );
        setIsBenchmarkEnabled(isCurrentMetricBenchmarked || false);

        benchmarkInitializedRef.current = true;
      }
    }

    if (!props.currentBenchmarkQueryCOPY && benchmarkInitializedRef.current) {
      // Reset if no benchmark query exists
      setBenchmarkOption('');
      setBenchmarkStartDate(null);
      setIsBenchmarkEnabled(false);
      benchmarkInitializedRef.current = false;
    }
  }, [props.currentBenchmarkQueryCOPY, props.activeObject.name, props.activeObject.query, props.hidden]);

  // Update checked5 when currentConversionsQueryCOPY changes
  React.useEffect(() => {
    if (
      !props.currentConversionsQueryCOPY?.query?.calculatedMetrics ||
      !props.currentConversionsQueryCOPY?.views?.[0]?.viewName
    ) {
      setChecked5(false);
      return;
    }

    const newChecked5 = props.currentConversionsQueryCOPY.query.calculatedMetrics.some((calcMetric: any) => {
      if (props.currentConversionsQueryCOPY.views[0].viewName.includes('facebook')) {
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#custom_conversions_value)';
      } else if (props.currentConversionsQueryCOPY.views[0].viewName.includes('adform')) {
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#custom_conversions)';
      } else if (props.currentConversionsQueryCOPY.views[0].viewName.includes('dv360')) {
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#total_conversions)';
      } else {
        return calcMetric.query === 'SUM(#conversions_cost)/SUM(#total_conversions)';
      }
    });

    setChecked5(newChecked5);
  }, [props.currentConversionsQueryCOPY]);

  // Create benchmark query function
  const createBenchmarkQuery = React.useCallback(() => {
    if (benchmarkOption && benchmarkStartDate && benchmarkEndDate) {
      const benchmarkQueryCopy = JSON.parse(JSON.stringify(props.currentQuery));

      // Keep only the metric with column equal to activeObject.name
      const filteredMetrics = benchmarkQueryCopy.query.metrics.filter(
        (metric: any) => metric.column === props.activeObject.name,
      );
      benchmarkQueryCopy.query.metrics = [];

      const filteredCalculatedMetrics = benchmarkQueryCopy.query.calculatedMetrics.filter(
        (calc: any) => calc.name === props.activeObject.name,
      );
      console.log('BENCH', props);
      benchmarkQueryCopy.query.calculatedMetrics = filteredCalculatedMetrics;

      // Filter detailedDimensions based on benchmarkable flag from selectedDataSource
      if (props.selectedDataSource?.dimensions) {
        benchmarkQueryCopy.query.detailedDimensions = benchmarkQueryCopy.query.detailedDimensions.filter(
          (queryDimension: any) => {
            // Find matching dimension in selectedDataSource
            const matchingSourceDimension = props.selectedDataSource?.dimensions?.find(
              (sourceDimension) => sourceDimension.dimension === queryDimension.column,
            );

            // If we found a matching dimension, check if it's benchmarkable
            // The benchmarkable property might be in different places depending on data structure
            if (matchingSourceDimension) {
              // Check if benchmarkable exists directly on the dimension
              if (matchingSourceDimension.hasOwnProperty('benchmarkable')) {
                return (matchingSourceDimension as any).benchmarkable !== false;
              }
              // Check if benchmarkable exists in detailedDimension
              if (
                matchingSourceDimension.detailedDimension &&
                (matchingSourceDimension.detailedDimension as any).hasOwnProperty('benchmarkable')
              ) {
                return (matchingSourceDimension.detailedDimension as any).benchmarkable !== false;
              }
            }

            // If no matching dimension found or no benchmarkable property, keep it (default behavior)
            return true;
          },
        );
        // if (benchmarkQueryCopy.query.detailedDimensions.length === 0) {
        //   benchmarkQueryCopy.query.detailedDimensions = [
        //     { column: 'client_code', name: 'client_code', hidden: false, id: 'client_code' },
        //   ];
        //   if (!benchmarkQueryCopy.query.orderBy.includes('client_code')) {
        //     benchmarkQueryCopy.query.orderBy.push('client_code');
        //   }
        // }
      }

      // Update orderBy to contain only IDs from filtered metrics and remaining dimensions
      const metricIds = filteredMetrics.map((metric: any) => metric.id);
      const dimensionIds = benchmarkQueryCopy.query.detailedDimensions.map((dim: any) => dim.id);
      benchmarkQueryCopy.query.orderBy = benchmarkQueryCopy.query.orderBy.filter(
        (id: string) =>
          metricIds.includes(id) ||
          dimensionIds.includes(id) ||
          benchmarkQueryCopy.query.calculatedMetrics?.some((calc: any) => calc.id === id),
      );

      // Remove campaign_id filter if it exists
      if (benchmarkQueryCopy.query.filters) {
        benchmarkQueryCopy.query.filters = benchmarkQueryCopy.query.filters.filter(
          (filter: any) => filter.column !== 'campaign_id',
        );
      }

      // Add client_code filter
      const clientCodeFilter = {
        column: 'client_code',
        filter: {
          filtertype: 'EQUAL' as any,
          datatype: 'STRING' as any,
          value: benchmarkQueryCopy.clients[0].client,
        },
      };

      // Add date filter
      const dateFilter = {
        column: 'date',
        filter: {
          datatype: 'DATE' as any,
          filtertype: 'BETWEEN' as any,
          from: benchmarkStartDate.toISOString().split('T')[0],
          to: benchmarkEndDate.toISOString().split('T')[0],
        },
      };

      // Add filters to existing filters or create new filters array
      if (!benchmarkQueryCopy.query.filters) {
        benchmarkQueryCopy.query.filters = [];
      }
      benchmarkQueryCopy.query.filters.push(clientCodeFilter, dateFilter);

      return benchmarkQueryCopy;
    }
    return null;
  }, [
    benchmarkOption,
    benchmarkStartDate,
    benchmarkEndDate,
    props.currentQuery,
    props.selectedDataSource,
    props.activeObject,
    activeCampaign,
  ]);

  // Function to get benchmarkable dimensions from current query
  const getBenchmarkableDimensions = React.useCallback(() => {
    if (!props.currentQuery?.query?.detailedDimensions || !props.selectedDataSource?.dimensions) {
      return [];
    }

    return props.currentQuery.query.detailedDimensions
      .filter((queryDimension: any) => {
        // Find matching dimension in selectedDataSource
        const matchingSourceDimension = props.selectedDataSource?.dimensions?.find(
          (sourceDimension: any) => sourceDimension.dimension === queryDimension.column,
        );

        // Check if it's benchmarkable
        if (matchingSourceDimension) {
          return (matchingSourceDimension as any).benchmarkable === true;
        }
        return false;
      })
      .map((dimension: any) => ({
        name: dimension.name,
        column: dimension.column,
      }));
  }, [props.currentQuery?.query?.detailedDimensions, props.selectedDataSource?.dimensions]);

  // Function to check if non-benchmarkable dimensions have filters
  const hasNonBenchmarkableDimensionWithFilter = React.useCallback(() => {
    if (
      !props.currentQuery?.query?.detailedDimensions ||
      !props.currentQuery?.query?.filters ||
      !props.selectedDataSource?.dimensions
    ) {
      return false;
    }

    // Get all non-benchmarkable dimensions from the current query
    const nonBenchmarkableDimensions = props.currentQuery.query.detailedDimensions.filter((queryDimension: any) => {
      // Find matching dimension in selectedDataSource
      const matchingSourceDimension = props.selectedDataSource?.dimensions?.find(
        (sourceDimension: any) => sourceDimension.dimension === queryDimension.column,
      );

      // Check if it's NOT benchmarkable
      if (matchingSourceDimension) {
        return (matchingSourceDimension as any).benchmarkable !== true;
      }
      return true; // If no matching dimension found, consider it non-benchmarkable
    });

    // Check if any of these non-benchmarkable dimensions have filters
    return nonBenchmarkableDimensions.some((dimension: any) => {
      return props.currentQuery.query.filters?.some((filter: any) => filter.column === dimension.column);
    });
  }, [
    props.currentQuery?.query?.detailedDimensions,
    props.currentQuery?.query?.filters,
    props.selectedDataSource?.dimensions,
  ]);

  // Function to check if current dimension is benchmarkable
  const isCurrentDimensionBenchmarkable = React.useCallback(() => {
    if (!props.selectedDataSource?.dimensions || !props.activeObject?.column) {
      return false;
    }

    // Find matching dimension in selectedDataSource (same logic as getBenchmarkableDimensions)
    const matchingSourceDimension = props.selectedDataSource.dimensions.find(
      (sourceDimension: any) => sourceDimension.dimension === props.activeObject.column,
    );

    // Check if it's benchmarkable
    return matchingSourceDimension && (matchingSourceDimension as any).benchmarkable === true;
  }, [props.selectedDataSource?.dimensions, props.activeObject?.column]);

  const foundIndex = props.currentQueryCOPY.query.detailedDimensions.findIndex(
    (dim: any) => dim.name === props.clickedHeader || dim.column === props.clickedHeader,
  );
  const foundIndexCC =
    props.currentConversionsQueryCOPY === undefined
      ? undefined
      : props.currentConversionsQueryCOPY.query.detailedDimensions.findIndex(
          (dim: any) => dim.name === props.clickedHeader,
        );
  const foundIndexBenchmark =
    props.currentBenchmarkQueryCOPY === undefined
      ? undefined
      : props.currentBenchmarkQueryCOPY.query.detailedDimensions.findIndex(
          (dim: any) => dim.name === props.clickedHeader || dim.column === props.clickedHeader,
        );
  const renderCostPerCC =
    props.currentConversionsQuery === undefined ? undefined : props.currentConversionsQuery.query.calculatedMetrics;
  const renderCostPer = props.currentQuery.query.calculatedMetrics.filter(
    (calcMetric: any) => calcMetric.name === props.clickedHeader,
  );

  const closeModal = () => {
    props.setCurrentQueryCOPY(props.currentQuery);
    props.openClose(props.clickedHeader);
  };

  const setapply = () => {
    // Save benchmark index to parent state on apply, but with a flag to prevent page change
    if (props.setBenchmarkIndex) {
      props.setBenchmarkIndex(localBenchmarkIndex);
    }
    props.openClose(props.clickedHeader);
  };

  // Use a ref to track if we've already processed this state combination
  const benchmarkProcessedRef = React.useRef<string>('');

  // Update benchmark query when benchmark options change (only for creating new benchmark queries)
  React.useEffect(() => {
    const currentStateKey = `${benchmarkOption}-${benchmarkStartDate?.getTime()}-${benchmarkEndDate?.getTime()}-${props.activeObject.name}`;

    // Only process if this combination hasn't been processed yet
    if (benchmarkProcessedRef.current === currentStateKey) {
      return;
    }

    // Only create new benchmark query if none exists and we have all required data
    if (
      benchmarkOption === 'historic_data' &&
      benchmarkStartDate &&
      benchmarkEndDate &&
      props.setCurrentBenchmarkQueryCOPY &&
      !props.currentBenchmarkQueryCOPY
    ) {
      const newBenchmarkQuery = createBenchmarkQuery();
      if (newBenchmarkQuery) {
        props.setCurrentBenchmarkQueryCOPY(newBenchmarkQuery);
        setIsBenchmarkEnabled(true);
        benchmarkProcessedRef.current = currentStateKey;
      }
    }
  }, [
    benchmarkOption,
    benchmarkStartDate,
    benchmarkEndDate,
    props.activeObject.name,
    props.setCurrentBenchmarkQueryCOPY,
    props.currentBenchmarkQueryCOPY,
    createBenchmarkQuery,
    setIsBenchmarkEnabled,
  ]);

  const displayChars = (char: any) => {
    let sign = '';
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    char === 'EQUAL'
      ? (sign = '=')
      : char === 'LT'
        ? (sign = '<')
        : char === 'LTE'
          ? (sign = '<=')
          : char === 'GT'
            ? (sign = '>')
            : char === 'GTE'
              ? (sign = '>=')
              : char === 'IN'
                ? (sign = 'in')
                : char === 'NOTIN'
                  ? (sign = 'out')
                  : null;
    return sign;
  };

  const handleSwitch = () => {
    setChecked(!checked);
    const index = props.currentQueryCOPY.query.detailedDimensions.findIndex(
      (dimension: any) => dimension.column === props.activeObject.column,
    );
    props.currentQueryCOPY.query.detailedDimensions[index].hidden = !checked;

    if (props.currentConversionsQueryCOPY !== undefined) {
      const indexConversion = props.currentConversionsQueryCOPY.query.detailedDimensions.findIndex(
        (dimension: any) => dimension.column === props.activeObject.column,
      );
      props.currentConversionsQueryCOPY.query.detailedDimensions[indexConversion].hidden = !checked;
    }

    if (props.currentBenchmarkQueryCOPY !== undefined) {
      const indexBenchmark = props.currentBenchmarkQueryCOPY.query.detailedDimensions.findIndex(
        (dimension: any) => dimension.column === props.activeObject.column,
      );
      if (indexBenchmark !== -1) {
        props.currentBenchmarkQueryCOPY.query.detailedDimensions[indexBenchmark].hidden = !checked;
      }
    }
  };

  const dimensionNameChange = (event: any) => {
    const index = props.currentQueryCOPY.query.detailedDimensions.findIndex(
      (dimension: any) => dimension.column === props.activeObject.column,
    );
    props.currentQueryCOPY.query.detailedDimensions[index].name = event.target.value;

    if (props.currentConversionsQueryCOPY !== undefined) {
      const indexConversion = props.currentConversionsQueryCOPY.query.detailedDimensions.findIndex(
        (dimension: any) => dimension.column === props.activeObject.column,
      );
      props.currentConversionsQueryCOPY.query.detailedDimensions[indexConversion].name = event.target.value;
    }

    if (props.currentBenchmarkQueryCOPY !== undefined) {
      const indexBenchmark = props.currentBenchmarkQueryCOPY.query.detailedDimensions.findIndex(
        (dimension: any) => dimension.column === props.activeObject.column,
      );
      if (indexBenchmark !== -1) {
        props.currentBenchmarkQueryCOPY.query.detailedDimensions[indexBenchmark].name = event.target.value;
      }
    }
  };

  const handleList = (value: any, actionMeta: any) => {
    if (actionMeta.action === 'remove-value') {
      if (filterList !== null) {
        setFilterList((ps: any) => [...ps.filter((elementName: any) => elementName !== actionMeta.removedValue.label)]);
      }
    }

    const newArray = value.map((element: any) => {
      const found = props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename?.find(
        (el: any) => el.after === element.label,
      );
      if (found !== undefined) {
        return found.before;
      } else {
        return element.label;
      }
    });
    setFilterList(newArray);
  };
  const handleFilterValue = (value: any) => {
    const found = props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename?.find(
      (el: any) => el.after === value.label,
    );
    if (found !== undefined) {
      setFilterValue(found.before);
    } else {
      setFilterValue(value.label);
    }
  };

  const filterRemove = (e: any) => {
    // Check if we're removing a metric filter based on active object
    const isMetricFilter = props.activeObject.hasOwnProperty('aggregation');

    if (isMetricFilter) {
      // Remove from groupFilters for metrics
      if (props.currentQueryCOPY.query.groupFilters) {
        props.currentQueryCOPY.query.groupFilters = props.currentQueryCOPY.query.groupFilters.filter(
          (remove: any) => remove.column !== e,
        );
      }

      if (props.currentConversionsQueryCOPY?.query?.groupFilters) {
        props.currentConversionsQueryCOPY.query.groupFilters =
          props.currentConversionsQueryCOPY.query.groupFilters.filter((remove: any) => remove.column !== e);
      }

      if (props.currentBenchmarkQueryCOPY?.query?.groupFilters) {
        props.currentBenchmarkQueryCOPY.query.groupFilters = props.currentBenchmarkQueryCOPY.query.groupFilters.filter(
          (remove: any) => remove.column !== e,
        );
      }
    } else {
      // Remove from filters for dimensions (existing logic)
      props.currentQueryCOPY.query.filters = props.currentQueryCOPY.query.filters.filter(
        (remove: any) => remove.column !== e,
      );

      if (props.currentConversionsQueryCOPY) {
        props.currentConversionsQueryCOPY.query.filters = props.currentConversionsQueryCOPY.query.filters.filter(
          (remove: any) => remove.column !== e,
        );
      }

      if (props.currentBenchmarkQueryCOPY && props.currentBenchmarkQueryCOPY.query.filters) {
        props.currentBenchmarkQueryCOPY.query.filters = props.currentBenchmarkQueryCOPY.query.filters.filter(
          (remove: any) => remove.column !== e,
        );
      }
    }

    setFilterStatus(!filterStatus);
  };

  const handleFilterSave = () => {
    // Check if we need to show confirmation for benchmark removal
    if (props.currentBenchmarkQueryCOPY && !isCurrentDimensionBenchmarkable()) {
      setPendingFilterData({
        filterType,
        filterList,
        filterValue,
      });
      setShowBenchmarkRemovalConfirmation(true);
      return;
    }

    // Proceed with normal filter save
    saveFilterDirectly();
  };

  const saveFilterDirectly = () => {
    const checkChangedDimensionName = (headerName: string) => {
      const foundDim = props.currentQuery.query.detailedDimensions.find((dim: any) => dim.name === headerName);
      if (foundDim) {
        if (
          foundDim.column === 'yw' ||
          foundDim.column === 'id' ||
          foundDim.column === 'month' ||
          foundDim.column === 'year'
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };

    const found = props.currentQueryCOPY.query.filters.find(
      (element: any) => element.column === props.activeObject.column,
    );
    const index = props.currentQueryCOPY.query.filters.indexOf(found);

    if (index === -1) {
      props.currentQueryCOPY.query.filters.push({
        column: props.activeObject.column,
        filter: {
          filtertype: filterType,
          datatype:
            props.clickedHeader === 'yw' ||
            props.clickedHeader.endsWith('id') ||
            props.clickedHeader.endsWith('month') ||
            props.clickedHeader.endsWith('year') ||
            checkChangedDimensionName(props.clickedHeader)
              ? datatype.NUMBER
              : props.activeObject.column === 'date'
                ? datatype.DATE
                : datatype.STRING,
          ...(filterType === 'IN' || filterType === 'NOTIN' ? { list: filterList } : { value: filterValue }),
        },
      });
    } else {
      props.currentQueryCOPY.query.filters[index] = {
        column: props.activeObject.column,
        filter: {
          filtertype: filterType,
          datatype: datatype.STRING,
          ...(filterType === 'IN' || filterType === 'NOTIN' ? { list: filterList } : { value: filterValue }),
        },
      };
    }

    if (props.currentConversionsQueryCOPY !== undefined) {
      const foundConversion = props.currentConversionsQueryCOPY.query.filters.find(
        (element: any) => element.column === props.activeObject.column,
      );
      const indexConversion = props.currentConversionsQueryCOPY.query.filters.indexOf(foundConversion);

      if (indexConversion === -1) {
        props.currentConversionsQueryCOPY.query.filters.push({
          column: props.activeObject.column,
          filter: {
            filtertype: filterType,
            datatype:
              props.clickedHeader === 'yw' ||
              props.clickedHeader.endsWith('id') ||
              props.clickedHeader.endsWith('month') ||
              props.clickedHeader.endsWith('year')
                ? datatype.NUMBER
                : datatype.STRING,
            ...(filterType === 'IN' || filterType === 'NOTIN' ? { list: filterList } : { value: filterValue }),
          },
        });
      } else {
        props.currentConversionsQueryCOPY.query.filters[index] = {
          column: props.activeObject.column,
          filter: {
            filtertype: filterType,
            datatype: datatype.STRING,
            ...(filterType === 'IN' || filterType === 'NOTIN' ? { list: filterList } : { value: filterValue }),
          },
        };
      }
    }

    if (props.currentBenchmarkQueryCOPY !== undefined && props.currentBenchmarkQueryCOPY.query.filters) {
      const foundBenchmark = props.currentBenchmarkQueryCOPY.query.filters.find(
        (element: any) => element.column === props.activeObject.column,
      );
      const indexBenchmark = props.currentBenchmarkQueryCOPY.query.filters.indexOf(foundBenchmark);

      if (indexBenchmark === -1) {
        props.currentBenchmarkQueryCOPY.query.filters.push({
          column: props.activeObject.column,
          filter: {
            filtertype: filterType,
            datatype:
              props.clickedHeader === 'yw' ||
              props.clickedHeader.endsWith('id') ||
              props.clickedHeader.endsWith('month') ||
              props.clickedHeader.endsWith('year')
                ? datatype.NUMBER
                : datatype.STRING,
            ...(filterType === 'IN' || filterType === 'NOTIN' ? { list: filterList } : { value: filterValue }),
          },
        });
      } else {
        props.currentBenchmarkQueryCOPY.query.filters[indexBenchmark] = {
          column: props.activeObject.column,
          filter: {
            filtertype: filterType,
            datatype: datatype.STRING,
            ...(filterType === 'IN' || filterType === 'NOTIN' ? { list: filterList } : { value: filterValue }),
          },
        };
      }
    }

    setFilterStatus(!filterStatus);
    setisFilterToggle(!filterToggle);
    setFilterValue(null);
    setFilterType(filtertype.EQUAL);
  };

  const handleBenchmarkRemovalConfirmed = () => {
    // Remove benchmark query
    handleRemoveBenchmark();

    // Restore pending filter data
    if (pendingFilterData) {
      setFilterType(pendingFilterData.filterType);
      setFilterList(pendingFilterData.filterList);
      setFilterValue(pendingFilterData.filterValue);

      // Save the filter
      saveFilterDirectly();
    }

    // Clean up
    setShowBenchmarkRemovalConfirmation(false);
    setPendingFilterData(null);
  };

  const handleBenchmarkRemovalCancelled = () => {
    setShowBenchmarkRemovalConfirmation(false);
    setPendingFilterData(null);
  };

  const handleMetricFilterSave = () => {
    // Initialize groupFilters array if it doesn't exist
    if (!props.currentQueryCOPY.query.groupFilters) {
      props.currentQueryCOPY.query.groupFilters = [];
    }

    const found = props.currentQueryCOPY.query.groupFilters.find(
      (element: any) => element.column === props.activeObject.column,
    );
    const index = props.currentQueryCOPY.query.groupFilters.indexOf(found);

    const newFilter = {
      column: props.activeObject.column,
      filter: {
        filtertype: metricFilterType,
        datatype: datatype.NUMBER,
        value: metricFilterValue,
      },
    };

    if (index === -1) {
      props.currentQueryCOPY.query.groupFilters.push(newFilter);
    } else {
      props.currentQueryCOPY.query.groupFilters[index] = newFilter;
    }

    // Sync with conversions query
    if (props.currentConversionsQueryCOPY) {
      if (!props.currentConversionsQueryCOPY.query.groupFilters) {
        props.currentConversionsQueryCOPY.query.groupFilters = [];
      }

      const foundConversion = props.currentConversionsQueryCOPY.query.groupFilters.find(
        (element: any) => element.column === props.activeObject.column,
      );
      const indexConversion = props.currentConversionsQueryCOPY.query.groupFilters.indexOf(foundConversion);

      if (indexConversion === -1) {
        props.currentConversionsQueryCOPY.query.groupFilters.push(newFilter);
      } else {
        props.currentConversionsQueryCOPY.query.groupFilters[indexConversion] = newFilter;
      }
    }

    // Sync with benchmark query
    if (props.currentBenchmarkQueryCOPY?.query) {
      if (!props.currentBenchmarkQueryCOPY.query.groupFilters) {
        props.currentBenchmarkQueryCOPY.query.groupFilters = [];
      }

      const foundBenchmark = props.currentBenchmarkQueryCOPY.query.groupFilters.find(
        (element: any) => element.column === props.activeObject.column,
      );
      const indexBenchmark = props.currentBenchmarkQueryCOPY.query.groupFilters.indexOf(foundBenchmark);

      if (indexBenchmark === -1) {
        props.currentBenchmarkQueryCOPY.query.groupFilters.push(newFilter);
      } else {
        props.currentBenchmarkQueryCOPY.query.groupFilters[indexBenchmark] = newFilter;
      }
    }

    setMetricFilterToggle(true);
    setMetricFilterValue('');
    setMetricFilterType(filtertype.EQUAL);
    setFilterStatus(!filterStatus);
  };

  const metricNameChange = (event: any) => {
    const index = props.currentQueryCOPY.query.metrics.findIndex(
      (metric: any) =>
        metric.column === props.activeObject.column && metric.aggregation === props.activeObject.aggregation,
    );
    props.currentQueryCOPY.query.metrics[index].name = event.target.value;
    const found = props.testObject.find((oneObject: any) => oneObject.name === props.activeObject.name);
    found.name = event.target.value;
  };

  const metricDecimals = (e: any) => {
    const index = props.currentQueryCOPY.query.metrics.findIndex(
      (metric: any) => metric.column === props.activeObject.column,
    );

    props.currentQueryCOPY.query.metrics[index].decimals = Number(e.target.value);
    const found = props.testObject.find((oneObject: any) => (oneObject.name = props.activeObject.name));
    found.decimals = Number(e.target.value);
  };

  const handleMetricremove = () => {
    if (checked3 === true) {
      //REMOVE ID FROM ORDERBY
      props.currentQueryCOPY.query.orderBy = props.currentQueryCOPY.query.orderBy.filter(
        (id: any) => id !== props.activeObject.id,
      );
      //REMOVE FROM COPY ARRAY
      props.currentQueryCOPY.query.metrics = props.currentQueryCOPY.query.metrics.filter(
        (metric: any) => metric.name !== props.activeObject.name,
      );
      // CHANGE ACTIVE TO FALSE
      props.activeObject.active = !checked3;
      const found = props.testObject.find((oneObject: any) => (oneObject.name = props.activeObject.name));
      found.active = !checked3;
    } else {
      props.currentQueryCOPY.query.orderBy = props.currentQueryCOPY.query.orderBy.concat([props.activeObject.id]);
      props.currentQueryCOPY.query.metrics = props.currentQueryCOPY.query.metrics.concat([
        {
          aggregation: props.activeObject.aggregation,
          column: props.activeObject.column,
          decimals: props.activeObject.decimals,
          id: props.activeObject.id,
          name: props.activeObject.name,
        },
      ]);
      props.activeObject.active = !checked3;
      const found = props.testObject.find((oneObject: any) => (oneObject.name = props.activeObject.name));
      found.active = !checked3;
    }
    setChecked3(!checked3);
  };

  const handleCostPer = () => {
    if (checked2 === false) {
      const id = Math.floor(Math.random() * Date.now()).toString();

      props.currentQueryCOPY.query.orderBy = props.currentQueryCOPY.query.orderBy.concat([id]);
      props.currentQueryCOPY.query.calculatedMetrics = props.currentQueryCOPY.query.calculatedMetrics.concat([
        {
          name: `Cost Per ${props.activeObject.name}`,
          query: `SUM(#cost)/SUM(#${props.activeObject.column})`,
          decimals: 2,
          id: id,
        },
      ]);
    } else {
      //  const findNewCostPerName = props.currentQuery.query.calculatedMetrics.some((calMet: any) => calMet.query === `SUM(#cost)/SUM(#${props.clickedHeader})`)
      const element = props.currentQueryCOPY.query.calculatedMetrics.find(
        (calMet: any) => calMet.query === `SUM(#cost)/SUM(#${props.activeObject.column})`,
      );
      props.currentQueryCOPY.query.orderBy = props.currentQueryCOPY.query.orderBy.filter(
        (id: any) => id !== element.id,
      );

      props.currentQueryCOPY.query.calculatedMetrics = props.currentQueryCOPY.query.calculatedMetrics.filter(
        (metric: any) => metric.query !== `SUM(#cost)/SUM(#${props.activeObject.column})`,
      );
    }
    setChecked2(!checked2);
  };

  const handleCostPerRemove = () => {
    if (checked4 === true) {
      props.currentQueryCOPY.query.orderBy = props.currentQueryCOPY.query.orderBy.filter(
        (id: any) => id !== props.activeObject.id,
      );
      props.currentQueryCOPY.query.calculatedMetrics = props.currentQueryCOPY.query.calculatedMetrics.filter(
        (metric: any) => metric.name !== props.activeObject.name,
      );

      // Also remove from benchmark query if it exists
      if (props.currentBenchmarkQueryCOPY?.query?.calculatedMetrics) {
        props.currentBenchmarkQueryCOPY.query.calculatedMetrics =
          props.currentBenchmarkQueryCOPY.query.calculatedMetrics.filter(
            (el: any) => el.query !== props.activeObject.query,
          );
        if (props.currentBenchmarkQueryCOPY.query.orderBy) {
          const benchmarkCalculatedMetricsIds = props.currentBenchmarkQueryCOPY.query.calculatedMetrics.map(
            (item: any) => item.id,
          );
          props.currentBenchmarkQueryCOPY.query.orderBy = props.currentBenchmarkQueryCOPY.query.orderBy.filter(
            (orderById: any) => benchmarkCalculatedMetricsIds.includes(orderById),
          );
        }

        // If no calculated metrics left, remove entire benchmark query
        if (props.currentBenchmarkQueryCOPY.query.calculatedMetrics.length === 0) {
          if (props.setCurrentBenchmarkQueryCOPY) {
            props.setCurrentBenchmarkQueryCOPY(undefined);
          }
          setBenchmarkOption('');
          setBenchmarkStartDate(null);
          setIsBenchmarkEnabled(false);
          benchmarkInitializedRef.current = false;
        }
      }
    } else {
      const id = Math.floor(Math.random() * Date.now()).toString();
      props.currentQueryCOPY.query.orderBy = props.currentQueryCOPY.query.orderBy.concat([id]);
      props.currentQueryCOPY.query.calculatedMetrics =
        props.currentQueryCOPY.query.calculatedMetrics.concat(renderCostPer);
    }
    setChecked4(!checked4);
  };

  const handleAggregation = (event: any) => {
    const index = props.currentQueryCOPY.query.metrics.findIndex(
      (metric: any) => metric.column === props.activeObject.column,
    );
    props.currentQueryCOPY.query.metrics[index].aggregation = event.target.value;
    const found = props.testObject.find((oneObject: any) => (oneObject.name = props.activeObject.name));
    found.aggregation = event.target.value;
  };

  const calcMetricNameChange = (event: any) => {
    const index = props.currentQueryCOPY.query.calculatedMetrics.findIndex(
      (metric: any) => metric.query === props.activeObject.query,
    );
    // const findOriginalName = props.currentQuery.query.calculatedMetrics.find(
    //   (cm: any) => cm.query === props.activeObject.query,
    // ).name;
    props.currentQueryCOPY.query.calculatedMetrics[index].name = event.target.value;
    props.mainReference.query.calculatedMetrics[index].name = event.target.value;

    // Sync with benchmark query if it exists
    if (props.currentBenchmarkQueryCOPY?.query?.calculatedMetrics) {
      const benchmarkIndex = props.currentBenchmarkQueryCOPY.query.calculatedMetrics.findIndex(
        (metric: any) => metric.query === props.activeObject.query,
      );
      if (benchmarkIndex !== -1) {
        // Use the main query name as the base (without benchmark suffix) and add benchmark
        props.currentBenchmarkQueryCOPY.query.calculatedMetrics[benchmarkIndex].name =
          event.target.value /* + ' benchmark' */;
      }
    }
  };

  const calcMetricDecimals = (e: any) => {
    const index = props.currentQueryCOPY.query.calculatedMetrics.findIndex(
      (metric: any) => metric.query === props.activeObject.query,
    );
    props.currentQueryCOPY.query.calculatedMetrics[index].decimals = Number(e.target.value);
    props.mainReference.query.calculatedMetrics[index].decimals = Number(e.target.value);

    // Sync with benchmark query if it exists
    if (props.currentBenchmarkQueryCOPY?.query?.calculatedMetrics) {
      const benchmarkIndex = props.currentBenchmarkQueryCOPY.query.calculatedMetrics.findIndex(
        (metric: any) => metric.query === props.activeObject.query,
      );
      if (benchmarkIndex !== -1) {
        props.currentBenchmarkQueryCOPY.query.calculatedMetrics[benchmarkIndex].decimals = Number(e.target.value);
      }
    }
  };

  // Function to add/remove calculated metric from existing benchmark query
  const handleToggleBenchmarkMetric = () => {
    if (!props.currentBenchmarkQueryCOPY || !props.setCurrentBenchmarkQueryCOPY) {
      return;
    }

    const benchmarkQueryCopy = JSON.parse(JSON.stringify(props.currentBenchmarkQueryCOPY));

    if (isBenchmarkEnabled) {
      // Remove current calculated metric from benchmark query
      benchmarkQueryCopy.query.calculatedMetrics = benchmarkQueryCopy.query.calculatedMetrics.filter(
        (calc: any) => calc.query !== props.activeObject.query,
      );

      // Remove from orderBy if needed
      benchmarkQueryCopy.query.orderBy = benchmarkQueryCopy.query.orderBy.filter(
        (id: string) =>
          !props.currentBenchmarkQueryCOPY.query.calculatedMetrics.some(
            (calc: any) => calc.query === props.activeObject.query && calc.id === id,
          ),
      );

      // If no calculated metrics left, remove entire benchmark query
      if (benchmarkQueryCopy.query.calculatedMetrics.length === 0) {
        props.setCurrentBenchmarkQueryCOPY(undefined);
        setBenchmarkOption('');
        setBenchmarkStartDate(null);
        setIsBenchmarkEnabled(false);
        benchmarkInitializedRef.current = false;
        return;
      }
    } else {
      // Add current calculated metric to benchmark query
      const newCalculatedMetric = {
        name: props.activeObject.name /* + ' benchmark' */,
        query: props.activeObject.query,
        decimals: props.activeObject.decimals,
        id: props.activeObject.id,
        userDefined: props.activeObject.userDefined,
      };

      benchmarkQueryCopy.query.calculatedMetrics.push(newCalculatedMetric);

      // Add to orderBy
      if (!benchmarkQueryCopy.query.orderBy.includes(props.activeObject.id)) {
        benchmarkQueryCopy.query.orderBy.push(props.activeObject.id);
      }
    }

    props.setCurrentBenchmarkQueryCOPY(benchmarkQueryCopy);
    setIsBenchmarkEnabled(!isBenchmarkEnabled);
  };

  // Function to remove benchmark query
  const handleRemoveBenchmark = () => {
    if (props.setCurrentBenchmarkQueryCOPY) {
      props.setCurrentBenchmarkQueryCOPY(undefined);
    }
    setBenchmarkOption('');
    setBenchmarkStartDate(null);
    setIsBenchmarkEnabled(false);
    benchmarkInitializedRef.current = false;
  };

  // Function to update benchmark dates for all metrics
  const handleBenchmarkDateChange = (newStartDate: Date | null) => {
    setBenchmarkStartDate(newStartDate);

    if (props.currentBenchmarkQueryCOPY && props.setCurrentBenchmarkQueryCOPY && newStartDate && benchmarkEndDate) {
      const benchmarkQueryCopy = JSON.parse(JSON.stringify(props.currentBenchmarkQueryCOPY));

      // Update date filter
      const dateFilterIndex = benchmarkQueryCopy.query.filters?.findIndex((filter: any) => filter.column === 'date');
      if (dateFilterIndex !== -1) {
        benchmarkQueryCopy.query.filters[dateFilterIndex].filter.from = newStartDate.toISOString().split('T')[0];
        benchmarkQueryCopy.query.filters[dateFilterIndex].filter.to = benchmarkEndDate.toISOString().split('T')[0];

        props.setCurrentBenchmarkQueryCOPY(benchmarkQueryCopy);
      }
    }
  };

  const handleBenchmarkEndDateChange = (newEndDate: Date | null) => {
    setBenchmarkEndDate(newEndDate);

    if (props.currentBenchmarkQueryCOPY && props.setCurrentBenchmarkQueryCOPY && benchmarkStartDate && newEndDate) {
      const benchmarkQueryCopy = JSON.parse(JSON.stringify(props.currentBenchmarkQueryCOPY));

      // Update date filter
      const dateFilterIndex = benchmarkQueryCopy.query.filters?.findIndex((filter: any) => filter.column === 'date');
      if (dateFilterIndex !== -1) {
        benchmarkQueryCopy.query.filters[dateFilterIndex].filter.from = benchmarkStartDate.toISOString().split('T')[0];
        benchmarkQueryCopy.query.filters[dateFilterIndex].filter.to = newEndDate.toISOString().split('T')[0];

        props.setCurrentBenchmarkQueryCOPY(benchmarkQueryCopy);
      }
    }
  };

  const handleAddCostPerCustomConversion = () => {
    if (checked5 === true) {
      const arr = props.currentConversionsQueryCOPY.query.calculatedMetrics.map((e: any) => e.id);
      props.currentConversionsQueryCOPY.query.orderBy = props.currentConversionsQueryCOPY.query.orderBy.filter(
        (id: any) => {
          return !arr.includes(id);
        },
      );
      props.currentConversionsQueryCOPY.query.calculatedMetrics = [];
    } else {
      const ccID = Math.floor(Math.random() * Date.now()).toString();

      props.currentConversionsQueryCOPY.query.calculatedMetrics.push({
        name: `Cost per`,
        query: props.currentConversionsQueryCOPY.views[0].viewName.includes('facebook')
          ? 'SUM(#conversions_cost)/SUM(#custom_conversions_value)'
          : props.currentConversionsQueryCOPY.views[0].viewName.includes('adform')
            ? 'SUM(#conversions_cost)/SUM(#custom_conversions)'
            : props.currentConversionsQueryCOPY.views[0].viewName.includes('dv360')
              ? 'SUM(#conversions_cost)/SUM(#total_conversions)'
              : 'SUM(#conversions_cost)/SUM(#total_conversions)',
        decimals: 2,
        id: ccID,
      });
      props.currentConversionsQueryCOPY.query.orderBy.push(ccID);
    }
    setChecked5(!checked5);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [lengthCounter, setLengthCounter] = useState<any>();
  const handleItemNameChange = () => {
    // FIRST WE CHECK IF RENAME HAS BEEN DONE ON SELECTED ITEM
    let preSelected = '';
    if (props.currentQueryCOPY.query.detailedDimensions[foundIndex]?.rename) {
      if (props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename?.some((el: any) => el.after === oldName)) {
        const selected = props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename?.filter(
          (el: any) => el.after === oldName,
        );
        preSelected = selected[0].before;
      }

      // WE CHECK IF RENAME PROP EXISTS AND IF YES DOES IT CONTAIN SELECTED ITEM(FIRST REMOVE AND THEN ADD NEW) ELSE JUST ADD
      if (
        props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename?.some(
          (el: any) => el.before === (preSelected.length > 0 ? preSelected : oldName),
        )
      ) {
        props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename =
          props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.filter(
            (el: any) => el.before !== (preSelected.length > 0 ? preSelected : oldName),
          );
        props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.push({
          before: preSelected.length > 0 ? preSelected : oldName,
          after: newName,
        });
        // CHANGE ON CONVERSION QUERY
        if (props.currentConversionsQueryCOPY !== undefined) {
          props.currentConversionsQueryCOPY.query.detailedDimensions[foundIndexCC].rename =
            props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.filter(
              (el: any) => el.before !== (preSelected.length > 0 ? preSelected : oldName),
            );
          props.currentConversionsQueryCOPY.query.detailedDimensions[foundIndexCC].rename.push({
            before: preSelected.length > 0 ? preSelected : oldName,
            after: newName,
          });
        }
        // CHANGE ON BENCHMARK QUERY
        if (
          props.currentBenchmarkQueryCOPY !== undefined &&
          foundIndexBenchmark !== undefined &&
          foundIndexBenchmark !== -1
        ) {
          if (!props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename) {
            props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename = [];
          }
          props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename =
            props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename.filter(
              (el: any) => el.before !== (preSelected.length > 0 ? preSelected : oldName),
            );
          props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename.push({
            before: preSelected.length > 0 ? preSelected : oldName,
            after: newName,
          });
        }
      } else {
        props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.push({ before: oldName, after: newName });
        if (props.currentConversionsQueryCOPY !== undefined) {
          props.currentConversionsQueryCOPY.query.detailedDimensions[foundIndexCC].rename.push({
            before: oldName,
            after: newName,
          });
        }
        if (
          props.currentBenchmarkQueryCOPY !== undefined &&
          foundIndexBenchmark !== undefined &&
          foundIndexBenchmark !== -1
        ) {
          if (!props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename) {
            props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename = [];
          }
          props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename.push({
            before: oldName,
            after: newName,
          });
        }
      }
    } else {
      props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename = [{ before: oldName, after: newName }];
      if (props.currentConversionsQueryCOPY !== undefined) {
        props.currentConversionsQueryCOPY.query.detailedDimensions[foundIndexCC].rename = [
          { before: oldName, after: newName },
        ];
      }
      if (
        props.currentBenchmarkQueryCOPY !== undefined &&
        foundIndexBenchmark !== undefined &&
        foundIndexBenchmark !== -1
      ) {
        props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename = [
          { before: oldName, after: newName },
        ];
      }
    }
    setOldName('');
    setNewName('');
    setLengthCounter(props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.length);
  };
  const handleRemoveNameChange = (val: any) => {
    setOldName(val);
    if (props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.some((el: any) => el.before === val)) {
      const newArray = props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.filter(
        (el: any) => el.before !== val,
      );
      props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename = newArray;
      if (props.currentConversionsQueryCOPY !== undefined) {
        const newArrayCC = props.currentConversionsQueryCOPY.query.detailedDimensions[foundIndexCC].rename.filter(
          (el: any) => el.before !== val,
        );
        props.currentConversionsQueryCOPY.query.detailedDimensions[foundIndexCC].rename = newArrayCC;
      }
      if (
        props.currentBenchmarkQueryCOPY !== undefined &&
        foundIndexBenchmark !== undefined &&
        foundIndexBenchmark !== -1
      ) {
        const newArrayBenchmark = props.currentBenchmarkQueryCOPY.query.detailedDimensions[
          foundIndexBenchmark
        ].rename.filter((el: any) => el.before !== val);
        props.currentBenchmarkQueryCOPY.query.detailedDimensions[foundIndexBenchmark].rename = newArrayBenchmark;
      }
    }
    setOldName('');
    setNewName('');
    setLengthCounter(props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.length);
  };

  const [ccNewName, setCCNewName] = useState<any>('');

  const handleCustomConversionNameChange = () => {
    const indexFound = props.currentConversionsQueryCOPY.query.detailedDimensions.findIndex(
      (dim: any) => dim.name === 'filter_name' || dim.name === 'conversion_name' || dim.name === 'CC_name', // 29.01.25 changed to dim.name from dim.column
    );
    //
    let preSelected = '';
    if (props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename) {
      if (
        props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename?.some(
          (el: any) => el.after === props.clickedHeader,
        )
      ) {
        const selected = props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename?.filter(
          (el: any) => el.after === props.clickedHeader,
        );
        preSelected = selected[0].before;
      }

      // WE CHECK IF RENAME PROP EXISTS AND IF YES DOES IT CONTAIN SELECTED ITEM(FIRST REMOVE AND THEN ADD NEW) ELSE JUST ADD
      if (
        props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename?.some(
          (el: any) => el.before === (preSelected.length > 0 ? preSelected : props.clickedHeader),
        )
      ) {
        props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename =
          props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename.filter(
            (el: any) => el.before !== (preSelected.length > 0 ? preSelected : props.clickedHeader),
          );
        props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename.push({
          before: preSelected.length > 0 ? preSelected : props.clickedHeader,
          after: ccNewName,
        });
      } else {
        props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename.push({
          before: props.clickedHeader,
          after: ccNewName,
        });
      }
    } else {
      props.currentConversionsQueryCOPY.query.detailedDimensions[indexFound].rename = [
        { before: props.clickedHeader, after: ccNewName },
      ];
    }
    setCCNewName('');
  };

  const CPconversionsCalcMetricDecimals = (e: any) => {
    props.currentConversionsQueryCOPY.query.calculatedMetrics[0].decimals = Number(e.target.value);
  };

  const CPcustomConversionNameChange = (event: any) => {
    props.currentConversionsQueryCOPY.query.calculatedMetrics[0].name = event.target.value;
  };

  // Helper function to check if metric filters exist
  const hasMetricFilters = () => {
    return props.currentQueryCOPY?.query?.groupFilters && props.currentQueryCOPY.query.groupFilters.length > 0;
  };

  // Handle hide total toggle
  const handleHideTotalToggle = () => {
    if (props.setHideTotal) {
      props.setHideTotal(!props.hideTotal);
    }
  };

  return (
    <Modal>
      {props.hidden && (
        <HeadModul>
          <button type="button" className="x" onClick={() => closeModal()}>
            {' '}
            <IoMdClose className="closeIcon" />
          </button>
          <ModulContainer>
            {/*------------------------------------------------------------- METRIC VARIANT-------------------------------------------*/}
            {props.activeObject.hasOwnProperty('aggregation') && (
              <div className="grid">
                {/* DECIMAL NUMBER*/}
                <Container className="containerBox">
                  <label>Number of Decimals</label>
                  <select
                    defaultValue={props.activeObject.decimals}
                    onChange={(e) => metricDecimals(e)}
                    //  onChange={(e) => (props.activeObject.decimals = Number(e.target.value))}
                  >
                    <option disabled value="">
                      {' '}
                      -- select an option --{' '}
                    </option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                </Container>

                {/* DISPLAY NAME */}
                <Container className="containerBox">
                  <label>Change display name:</label>
                  <input
                    type="text"
                    placeholder={props.activeObject.name}
                    onChange={(event) => metricNameChange(event)}
                  />
                </Container>

                {/* AGGREGATION */}
                <Container className="containerBox">
                  <label>Aggregation</label>
                  <select defaultValue={props.activeObject.aggregation} onChange={(e) => handleAggregation(e)}>
                    {(Object.keys(metricFunction) as Array<keyof typeof metricFunction>).map((aggregation) => (
                      <option key={aggregation} value={aggregation}>
                        {aggregation}
                      </option>
                    ))}
                  </select>
                </Container>

                {/* METRIC FILTER */}
                <Container className="containerBox">
                  <label>Filters</label>

                  {metricFilterToggle ? (
                    <>
                      {props.currentQueryCOPY.query.groupFilters?.find(
                        (x: any) => x.column === props.activeObject.column,
                      ) !== undefined ? (
                        <p></p>
                      ) : (
                        <button
                          className="fBTN"
                          type="button"
                          onClick={() => setMetricFilterToggle(!metricFilterToggle)}
                        >
                          ADD FILTER
                        </button>
                      )}

                      {props.currentQueryCOPY.query.groupFilters?.map((filter: any, index: any) => {
                        if (filter.column === props.activeObject.column) {
                          return (
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={index}>
                              <label className="removelabel">
                                {filter.column} {displayChars(filter.filter.filtertype)} {filter.filter.value}
                              </label>
                              <AiOutlineDelete
                                onClick={() => filterRemove(filter.column)}
                                style={{ cursor: 'pointer' }}
                              />
                            </div>
                          );
                        }
                        return null;
                      })}
                    </>
                  ) : (
                    <FilterDrop>
                      <div className="wrapper" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="filterTitle">{props.activeObject.column}</div>
                        <select
                          value={metricFilterType}
                          onChange={(e) => setMetricFilterType(filtertype[e.target.value as keyof typeof filtertype])}
                        >
                          <option value="EQUAL">=</option>
                          <option value="GT">{'>'}</option>
                          <option value="GTE">{'>='}</option>
                          <option value="LT">{'<'}</option>
                          <option value="LTE">{'<='}</option>
                        </select>

                        <input
                          type="number"
                          value={metricFilterValue}
                          onChange={(e) => setMetricFilterValue(e.target.value)}
                          placeholder="Enter numeric value"
                          style={{
                            padding: '0.5rem',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            marginTop: '0.5rem',
                          }}
                        />
                      </div>
                      <div className="btnz">
                        <button
                          className="fBTN"
                          type="button"
                          onClick={() => setMetricFilterToggle(!metricFilterToggle)}
                        >
                          CANCEL
                        </button>
                        {metricFilterValue && metricFilterType && (
                          <DarkButton className="fBTN" type="button" onClick={handleMetricFilterSave}>
                            SAVE
                          </DarkButton>
                        )}
                      </div>
                    </FilterDrop>
                  )}
                </Container>

                {/* TOGGLE COST PER */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Container className="containerBox">
                    <label>Cost per {props.activeObject.column} </label>
                    <Switch onChange={handleCostPer} checked={checked2} className="react-switch" />
                  </Container>

                  {checked2 === true && (
                    <Container className="containerBox">
                      <label>Remove {props.activeObject.name} </label>
                      <Switch onChange={handleMetricremove} checked={!checked3} className="react-switch" />
                    </Container>
                  )}
                </div>

                {/* METRIC FILTERS DISCLAIMER */}
                {hasMetricFilters() && (
                  <Container className="containerBox" style={{ marginTop: '1rem' }}>
                    <div
                      style={{
                        padding: '1rem',
                        backgroundColor: 'rgba(255, 193, 7, 0.1)',
                        borderRadius: '4px',
                        border: '1px solid rgba(255, 193, 7, 0.3)',
                        marginBottom: '1rem',
                        maxWidth: '400px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          marginBottom: '0.5rem',
                        }}
                      >
                        <span style={{ fontSize: '16px' }}>⚠️</span>
                        <h1 style={{ color: '#856404', margin: 0, fontSize: '1rem' }}>Total Row Disclaimer</h1>
                      </div>
                      <p
                        style={{
                          color: '#856404',
                          fontSize: '0.85rem',
                          margin: '0.5rem 0 0 0',
                          lineHeight: '1.4',
                        }}
                      >
                        Metric filters may affect total row calculations. The totals might not represent true campaign
                        totals when filters are applied to metrics.
                      </p>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'left',
                        gap: '1rem',
                        flexDirection: 'column',
                      }}
                    >
                      <div>
                        <label style={{ fontWeight: 'bold' }}>Hide Total Row</label>
                        <p style={{ color: '#666', fontSize: '0.85rem', margin: '0.25rem 0 0 0' }}>
                          Hide potentially incorrect totals when metric filters are applied
                        </p>
                      </div>
                      <Switch
                        onChange={handleHideTotalToggle}
                        checked={props.hideTotal || false}
                        className="react-switch"
                      />
                    </div>
                  </Container>
                )}
              </div>
            )}
            {/*--------------------------------------------------------------------- DIMENSIONS VARIANT-------------------------------------------*/}
            {props.activeObject.hasOwnProperty('hidden') && (
              <div className="grid">
                {/* DISPLAY NAME */}
                <Container className="containerBox">
                  <h1>Change display name:</h1>
                  <input
                    type="text"
                    placeholder={props.activeObject.name}
                    onChange={(event) => dimensionNameChange(event)}
                  />
                </Container>

                {/* HIDE DIMENSION */}
                <Container className="containerBox">
                  <h1>Hide Dimension</h1>
                  <Switch onChange={handleSwitch} checked={checked} className="react-switch" />
                </Container>

                {/* FILTER */}
                <Container className="containerBox">
                  <h1>Filters</h1>

                  {/* Benchmark Warning */}
                  {props.currentBenchmarkQueryCOPY && !isCurrentDimensionBenchmarkable() && (
                    <div
                      style={{
                        marginBottom: '1rem',
                        padding: '1rem',
                        backgroundColor: 'rgba(255, 193, 7, 0.08)',
                        border: '1px solid rgba(255, 193, 7, 0.25)',
                        borderRadius: '6px',
                        borderLeft: '4px solid #FFC107',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '0.75rem',
                        }}
                      >
                        <div
                          style={{
                            // backgroundColor: '#FFC107',
                            color: '#856404',
                            fontSize: '14px',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            minWidth: 'fit-content',
                          }}
                        >
                          ⚠️
                        </div>
                        <div>
                          <h3
                            style={{
                              color: '#856404',
                              fontSize: '0.95rem',
                              margin: '0 0 0.5rem 0',
                              fontWeight: '600',
                            }}
                          >
                            Benchmark Warning
                          </h3>
                          <p
                            style={{
                              color: '#856404',
                              fontSize: '0.85rem',
                              margin: 0,
                              lineHeight: '1.4',
                            }}
                          >
                            This dimension is not benchmarkable. Adding a filter here will remove your current benchmark
                            comparison.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                  {filterToggle ? (
                    <>
                      {props.currentQueryCOPY.query.filters.find((x: any) => x.column === props.clickedHeader) !==
                      undefined ? (
                        <p></p>
                      ) : (
                        <button className="fBTN" type="button" onClick={() => setisFilterToggle(!filterToggle)}>
                          ADD FILTER
                        </button>
                      )}

                      {props.currentQueryCOPY.query.filters.slice(1).map((filter: any, index: any) => (
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={index}>
                          <label className="removelabel">
                            {filter.column} {displayChars(filter.filter.filtertype)}{' '}
                            {filter.filter.value ? filter.filter.value : filter.filter.list}
                          </label>

                          {/*    {(filter.column === props.clickedHeader || props.currentQueryCOPY.query.detailedDimensions?.some((e: any) => e.name === props.clickedHeader)) && ( */}
                          <div>
                            {/*  <VscEdit onClick={() => setisFilterToggle(!filterToggle)} style={{ cursor: "pointer" }} /> */}
                            <AiOutlineDelete
                              onClick={() => filterRemove(filter.column)}
                              style={{ cursor: 'pointer' }}
                            />
                          </div>
                          {/*    )} */}
                        </div>
                      ))}
                    </>
                  ) : (
                    <FilterDrop>
                      <div className="wrapper" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="filterTitle">{props.clickedHeader}</div>
                        <select
                          name=""
                          id=""
                          defaultValue={filterType}
                          onChange={(e) => setFilterType(filtertype[e.target.value as keyof typeof filtertype])}
                        >
                          <option value=""></option>
                          <option value="IN">{'IN'}</option>
                          <option value="NOTIN">{'OUT'}</option>
                          <option value="EQUAL">=</option>
                          <option value="GT">{'>'}</option>
                          <option value="GTE">{'>='}</option>
                          <option value="LT">{'<'}</option>
                          <option value="LTE">{'<='}</option>
                        </select>

                        {filterType === 'IN' || filterType === 'NOTIN' ? (
                          <Select
                            defaultValue={filterList}
                            onChange={handleList}
                            options={filterOptions}
                            isMulti
                            className="react-select-container"
                            classNamePrefix="react-select"
                          />
                        ) : (
                          <Select
                            defaultValue={filterList}
                            onChange={handleFilterValue}
                            // onChange={(selectedOption) => setFilterValue(selectedOption.label)}
                            options={filterOptions}
                            className="react-select-container"
                            classNamePrefix="react-select"
                          />
                        )}
                      </div>
                      <div className="btnz">
                        <button className="fBTN" type="button" onClick={() => setisFilterToggle(!filterToggle)}>
                          CANCEL
                        </button>
                        {(filterList || filterValue) && filterType && (
                          <DarkButton className="fBTN" type="button" onClick={handleFilterSave}>
                            SAVE
                          </DarkButton>
                        )}
                      </div>
                    </FilterDrop>
                  )}
                </Container>

                <Container className="containerBox">
                  <h1>Change item name </h1>
                  from:
                  <select value={oldName} name="" id="" onChange={(e) => setOldName(e.target.value)}>
                    <option value=""> -- select an option -- </option>
                    {props.data.map((element: any, index: any) => (
                      <option key={index} value={element[props.clickedHeader]}>
                        {element[props.clickedHeader]}
                      </option>
                    ))}
                  </select>
                  to:
                  <input
                    type="text"
                    value={newName}
                    onChange={(e) => {
                      setNewName(e.target.value);
                    }}
                  />
                  {newName.length > 0 && oldName.length > 0 && (
                    <DarkButton
                      className="fBTN"
                      style={{ width: 'fit-content', marginTop: '0.5vw' }}
                      type="button"
                      onClick={handleItemNameChange}
                    >
                      SAVE
                    </DarkButton>
                  )}
                  {props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename && (
                    <label>
                      Selected:
                      {props.currentQueryCOPY.query.detailedDimensions[foundIndex].rename.map((el: any, index: any) => (
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={index}>
                          <label className="removelabel">
                            {el.before} <HiArrowNarrowRight /> {el.after}
                          </label>
                          <AiOutlineDelete
                            name={el.before}
                            onClick={(e) => {
                              setNewName(el.after);
                              setOldName(el.before);
                              handleRemoveNameChange(el.before);
                            }}
                            style={{ cursor: 'pointer' }}
                          />
                        </div>
                      ))}
                    </label>
                  )}
                </Container>
              </div>
            )}

            {/* ----------------------------------------------CALC METRICS VARIANT--------------------------------------------*/}
            {renderCostPer[0]?.hasOwnProperty('query') && (
              <div className="grid">
                {/* DECIMAL NUMBER*/}
                <Container className="containerBox">
                  <h1>Number of Decimals</h1>
                  <select
                    defaultValue={props.activeObject.decimals}
                    onChange={(e) => calcMetricDecimals(e)}
                    //  onChange={(e) => (props.activeObject.decimals = Number(e.target.value))}
                  >
                    <option disabled value="">
                      {' '}
                      -- select an option --{' '}
                    </option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                </Container>

                {/* DISPLAY NAME */}
                <Container className="containerBox">
                  <h1>Change display name:</h1>
                  <input
                    type="text"
                    placeholder={props.activeObject.name}
                    onChange={(event) => calcMetricNameChange(event)}
                  />
                  <small style={{ color: '#666', fontSize: '0.75rem', marginTop: '0.25rem', display: 'block' }}>
                    Note: This will also update the display name for any associated benchmark columns
                  </small>
                </Container>

                <Container className="containerBox" style={{ width: '50%' }}>
                  <h1>Remove {props.activeObject.name} </h1>
                  <Switch onChange={handleCostPerRemove} checked={!checked4} className="react-switch" />
                </Container>

                {/* BENCHMARK SECTION */}
                {hasNonBenchmarkableDimensionWithFilter() ? (
                  <Container className="containerBox">
                    <div
                      style={{
                        padding: '1rem',
                        backgroundColor: 'rgba(255, 193, 7, 0.1)',
                        borderRadius: '4px',
                        border: '1px solid rgba(255, 193, 7, 0.3)',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          marginBottom: '0.5rem',
                        }}
                      >
                        <span
                          style={{
                            // backgroundColor: '#FFC107',
                            // border: '1px solid #856404',
                            color: 'white',
                            fontSize: '12px',
                            padding: '2px 6px',
                            borderRadius: '3px',
                            fontWeight: 'bold',
                          }}
                        >
                          ⚠️
                        </span>
                        <h1 style={{ color: '#856404', margin: 0 }}>Benchmark Not Available</h1>
                      </div>
                      <p
                        style={{
                          color: '#856404',
                          fontSize: '0.85rem',
                          margin: '0.5rem 0 0 0',
                          lineHeight: '1.4',
                        }}
                      >
                        Benchmarking cannot be enabled because your query contains filters on non-benchmarkable
                        dimensions. Remove filters from non-benchmarkable dimensions to enable benchmark functionality.
                      </p>
                    </div>
                  </Container>
                ) : (
                  <Container className="containerBox">
                    {props.currentBenchmarkQueryCOPY ? (
                      // Show ON/OFF interface when benchmark query already exists
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '1rem',
                          }}
                        >
                          <div>
                            <h1>Benchmark {props.activeObject.name}</h1>
                            <p style={{ color: '#666', fontSize: '0.85rem', margin: '0.25rem 0 0 0' }}>
                              Add this metric to existing benchmark comparison
                            </p>
                          </div>
                          <Switch
                            onChange={handleToggleBenchmarkMetric}
                            checked={isBenchmarkEnabled}
                            className="react-switch"
                          />
                        </div>

                        {/* Show predefined date range buttons */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                          <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#666' }}>
                            Quick Date Ranges
                          </h2>
                          <div
                            style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                          >
                            {Object.entries(getPredefinedDateRanges).map(([key, range]) => (
                              <button
                                key={key}
                                type="button"
                                onClick={() => setPredefinedDateRange(key)}
                                style={{
                                  padding: '0.2rem 0.1rem',
                                  cursor: 'pointer',
                                  fontSize: '0.8rem',
                                }}
                              >
                                {range.label}
                              </button>
                            ))}
                          </div>
                        </div>

                        {/* Show date modification section */}
                        <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                          <div>
                            <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#666' }}>Start Date</h2>
                            <DatePicker
                              selected={benchmarkStartDate}
                              onChange={handleBenchmarkDateChange}
                              maxDate={benchmarkEndDate || undefined}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Select start date"
                              className="date-picker-input"
                            />
                          </div>

                          <div>
                            <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#666' }}>End Date</h2>
                            <DatePicker
                              selected={benchmarkEndDate}
                              onChange={handleBenchmarkEndDateChange}
                              maxDate={maxBenchmarkEndDate || undefined}
                              minDate={benchmarkStartDate || undefined}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Select end date"
                              className="date-picker-input"
                            />
                            <small
                              style={{ color: '#666', fontSize: '0.75rem', marginTop: '0.25rem', display: 'block' }}
                            >
                              End date cannot be later than{' '}
                              {maxBenchmarkEndDate
                                ? maxBenchmarkEndDate.toISOString().split('T')[0]
                                : 'campaign start date - 1 day'}
                            </small>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // Show original dropdown interface when no benchmark query exists
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '0.5rem',
                          }}
                        >
                          <h1>Benchmark {props.activeObject.name} against</h1>
                        </div>
                        <select value={benchmarkOption} onChange={(e) => setBenchmarkOption(e.target.value)}>
                          <option value="">-- select an option --</option>
                          <option value="historic_data">historic data</option>
                        </select>

                        {benchmarkOption === 'historic_data' && (
                          <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            {/* Show predefined date range buttons */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                              <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#666' }}>
                                Quick Date Ranges
                              </h2>
                              <div
                                style={{
                                  display: 'flex',
                                  gap: '0.5rem',
                                  flexWrap: 'wrap',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                {Object.entries(getPredefinedDateRanges).map(([key, range]) => (
                                  <button
                                    key={key}
                                    type="button"
                                    onClick={() => setPredefinedDateRange(key)}
                                    style={{
                                      padding: '0.2rem 0.1rem',
                                      cursor: 'pointer',
                                      fontSize: '0.8rem',
                                    }}
                                  >
                                    {range.label}
                                  </button>
                                ))}
                              </div>
                            </div>

                            <div>
                              <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#666' }}>Start Date</h2>
                              <DatePicker
                                selected={benchmarkStartDate}
                                onChange={(date: Date | null) => setBenchmarkStartDate(date)}
                                maxDate={benchmarkEndDate || undefined}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select start date"
                                className="date-picker-input"
                              />
                            </div>

                            <div>
                              <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#666' }}>End Date</h2>
                              <DatePicker
                                selected={benchmarkEndDate}
                                onChange={(date: Date | null) => setBenchmarkEndDate(date)}
                                maxDate={maxBenchmarkEndDate || undefined}
                                minDate={benchmarkStartDate || undefined}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select end date"
                                className="date-picker-input"
                              />
                              <small
                                style={{ color: '#666', fontSize: '0.75rem', marginTop: '0.25rem', display: 'block' }}
                              >
                                End date cannot be later than{' '}
                                {maxBenchmarkEndDate
                                  ? maxBenchmarkEndDate.toISOString().split('T')[0]
                                  : 'campaign start date - 1 day'}
                              </small>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Benchmarkable Dimensions List - only show when benchmark is active */}
                    {(props.currentBenchmarkQueryCOPY || benchmarkOption === 'historic_data') && (
                      <div
                        style={{
                          marginTop: '1.5rem',
                          padding: '1rem',
                          backgroundColor: 'rgba(76, 175, 80, 0.1)',
                          borderRadius: '4px',
                        }}
                      >
                        <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#333', fontWeight: 'bold' }}>
                          Benchmarkable Dimensions
                        </h2>
                        <p style={{ fontSize: '0.8rem', color: '#666', marginBottom: '0.75rem' }}>
                          These dimensions from your current query can be used for benchmarking:
                        </p>
                        {(() => {
                          const benchmarkableDims = getBenchmarkableDimensions();
                          if (benchmarkableDims.length === 0) {
                            return (
                              <p style={{ fontSize: '0.8rem', color: '#999', fontStyle: 'italic' }}>
                                No benchmarkable dimensions found in current query.
                              </p>
                            );
                          }
                          return (
                            <ul style={{ margin: 0, paddingLeft: '1rem', fontSize: '0.8rem' }}>
                              {benchmarkableDims.map((dim: any, index: number) => (
                                <li
                                  key={index}
                                  style={{
                                    marginBottom: '0.25rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                  }}
                                >
                                  <span
                                    style={{
                                      backgroundColor: '#4CAF50',
                                      color: 'white',
                                      fontSize: '10px',
                                      padding: '1px 4px',
                                      borderRadius: '3px',
                                      fontWeight: 'bold',
                                    }}
                                    title="This dimension is benchmarkable"
                                  >
                                    B
                                  </span>
                                  <span style={{ color: '#333' }}>{dim.name}</span>
                                </li>
                              ))}
                            </ul>
                          );
                        })()}
                      </div>
                    )}

                    {/* Benchmark Index Section - Show when benchmark is active */}
                    {(props.currentBenchmarkQueryCOPY || benchmarkOption === 'historic_data') && (
                      <div
                        style={{
                          marginTop: '1.5rem',
                          padding: '1rem',
                          backgroundColor: 'rgba(33, 150, 243, 0.1)',
                          borderRadius: '4px',
                          border: '1px solid rgba(33, 150, 243, 0.2)',
                        }}
                      >
                        <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#333', fontWeight: 'bold' }}>
                          Benchmark Index
                        </h2>
                        <p style={{ color: '#666', fontSize: '0.8rem', margin: '0 0 0.75rem 0' }}>
                          Choose how to display benchmark comparisons for this metric
                        </p>
                        <select
                          value={localBenchmarkIndex || BenchmarkingIndexValues.NONE}
                          onChange={(e) =>
                            setLocalBenchmarkIndex(
                              e.target.value === BenchmarkingIndexValues.NONE
                                ? null
                                : (e.target.value as BenchmarkingIndexValues),
                            )
                          }
                          style={{
                            width: '100%',
                            padding: '0.5rem',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            fontSize: '0.9rem',
                            fontFamily: 'inherit',
                            background: 'white',
                          }}
                        >
                          <option value={BenchmarkingIndexValues.NONE}>No benchmark index</option>
                          <option value={BenchmarkingIndexValues.PERCENTAGE}>Percentage Change (e.g., +50%)</option>
                          <option value={BenchmarkingIndexValues.INDEX}>Index (e.g., 150)</option>
                        </select>
                        <small style={{ color: '#666', fontSize: '0.75rem', marginTop: '0.5rem', display: 'block' }}>
                          {localBenchmarkIndex === BenchmarkingIndexValues.PERCENTAGE &&
                            'Shows percentage change vs benchmark (e.g., +50% means 50% higher than benchmark)'}
                          {localBenchmarkIndex === BenchmarkingIndexValues.INDEX &&
                            'Shows the metric as index percentage vs benchmark (e.g., 150% means 1.5x the benchmark)'}
                          {(!localBenchmarkIndex || localBenchmarkIndex === BenchmarkingIndexValues.NONE) &&
                            'Benchmark data will be shown as separate column without index calculation'}
                        </small>
                      </div>
                    )}
                  </Container>
                )}
              </div>
            )}

            {/*---------------------------------------------------------- CUSTOM CONVERSIONS VARIANT-------------------------------------------*/}
            {props.conversionsData?.some(
              (element: any) =>
                element.filter_name === props.clickedHeader ||
                element.conversion_name === props.clickedHeader ||
                element.CC_name === props.clickedHeader,
            ) && (
              <div className="grid">
                {/* DISPLAY NAME */}
                <Container className="containerBox">
                  <h1>Change display name:</h1>
                  <input
                    type="text"
                    value={ccNewName}
                    // placeholder={props.activeObject.name}
                    onChange={(e) => setCCNewName(e.target.value)}
                  />
                  <button
                    style={{ marginTop: '20px' }}
                    type="button"
                    onClick={() => handleCustomConversionNameChange()}
                  >
                    CONFIRM
                  </button>
                </Container>

                <Container className="containerBox" style={{ width: '50%' }}>
                  <label>Add Cost per {props.clickedHeader} </label>
                  <Switch onChange={handleAddCostPerCustomConversion} checked={checked5} className="react-switch" />
                </Container>
              </div>
            )}

            {/* ---------------------------------------------------------CONVERSION COST PER VARIANT-----------------------------------------------------------*/}
            {renderCostPerCC &&
              renderCostPerCC[0]?.hasOwnProperty('query') &&
              !props.activeObject.hasOwnProperty('hidden') &&
              !props.conversionsData?.some(
                (element: any) =>
                  element.filter_name === props.clickedHeader ||
                  element.conversion_name === props.clickedHeader ||
                  element.CC_name === props.clickedHeader,
              ) &&
              !props.activeObject.hasOwnProperty('aggregation') &&
              !renderCostPer[0]?.hasOwnProperty('query') && (
                <div className="grid">
                  {/* DECIMAL NUMBER*/}
                  <Container className="containerBox">
                    <h1>Number of Decimals</h1>
                    <select
                      defaultValue={props.activeObject.decimals}
                      onChange={(e) => CPconversionsCalcMetricDecimals(e)}
                      //  onChange={(e) => (props.activeObject.decimals = Number(e.target.value))}
                    >
                      <option disabled value="">
                        {' '}
                        -- select an option --{' '}
                      </option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </Container>

                  {/* DISPLAY NAME */}
                  <Container className="containerBox">
                    <h1>Change display name prefix:</h1>
                    <input
                      type="text"
                      placeholder={props.activeObject.name}
                      onChange={(event) => CPcustomConversionNameChange(event)}
                    />
                  </Container>

                  <Container className="containerBox" style={{ width: '50%' }}>
                    <h1>Remove {props.activeObject.name} </h1>
                    <Switch onChange={handleAddCostPerCustomConversion} checked={checked5} className="react-switch" />
                  </Container>
                </div>
              )}

            {/* ----------------------------------------------BENCHMARK COLUMN VARIANT--------------------------------------------*/}
            {typeof props.clickedHeader === 'string' && props.clickedHeader.includes(' benchmark') && (
              <div className="grid">
                <Container className="containerBox">
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '1rem',
                    }}
                  >
                    <div>
                      <h1>Benchmark Column: {props.clickedHeader}</h1>
                      <p style={{ color: '#666', fontSize: '0.9rem', margin: '0' }}>
                        This column shows benchmark data for comparison with current campaign metrics.
                      </p>
                    </div>
                    <Switch
                      onChange={handleRemoveBenchmark}
                      checked={!!props.currentBenchmarkQueryCOPY}
                      className="react-switch"
                    />
                  </div>

                  {/* Info about benchmark column naming */}
                  <div style={{ marginBottom: '1rem', padding: '0.5rem', fontSize: '0.85rem', color: '#666' }}>
                    <strong>Note:</strong> Benchmark columns cannot be renamed directly. To change the display name,
                    rename the original calculated metric instead.
                  </div>

                  {/* Benchmark Index Section for Benchmark Columns */}
                  {props.currentBenchmarkQueryCOPY && (
                    <div
                      style={{
                        marginTop: '1.5rem',
                        padding: '1rem',
                        backgroundColor: 'rgba(33, 150, 243, 0.1)',
                        borderRadius: '4px',
                        border: '1px solid rgba(33, 150, 243, 0.2)',
                      }}
                    >
                      <h2 style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: '#333', fontWeight: 'bold' }}>
                        Benchmark Index
                      </h2>
                      <p style={{ color: '#666', fontSize: '0.8rem', margin: '0 0 0.75rem 0' }}>
                        Choose how to display benchmark comparisons for all metrics
                      </p>
                      <select
                        value={localBenchmarkIndex || BenchmarkingIndexValues.NONE}
                        onChange={(e) =>
                          setLocalBenchmarkIndex(
                            e.target.value === BenchmarkingIndexValues.NONE
                              ? null
                              : (e.target.value as BenchmarkingIndexValues),
                          )
                        }
                        style={{
                          width: '100%',
                          padding: '0.5rem',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          fontSize: '0.9rem',
                          fontFamily: 'inherit',
                          background: 'white',
                        }}
                      >
                        <option value={BenchmarkingIndexValues.NONE}>No benchmark index</option>
                        <option value={BenchmarkingIndexValues.PERCENTAGE}>Percentage Change (e.g., +50%)</option>
                        <option value={BenchmarkingIndexValues.INDEX}>Index (e.g., 150)</option>
                      </select>
                      <small style={{ color: '#666', fontSize: '0.75rem', marginTop: '0.5rem', display: 'block' }}>
                        {localBenchmarkIndex === BenchmarkingIndexValues.PERCENTAGE &&
                          'Shows percentage change vs benchmark (e.g., +50% means 50% higher than benchmark)'}
                        {localBenchmarkIndex === BenchmarkingIndexValues.INDEX &&
                          'Shows the metric as index percentage vs benchmark (e.g., 150% means 1.5x the benchmark)'}
                        {(!localBenchmarkIndex || localBenchmarkIndex === BenchmarkingIndexValues.NONE) &&
                          'Benchmark data will be shown as separate column without index calculation'}
                      </small>
                    </div>
                  )}
                </Container>
              </div>
            )}
          </ModulContainer>

          <DarkButton style={{ alignSelf: 'flex-end' }} type="button" onClick={setapply}>
            OK
          </DarkButton>
        </HeadModul>
      )}

      {/* Benchmark Removal Confirmation Dialog */}
      {showBenchmarkRemovalConfirmation && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10000,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '2.5rem',
              borderRadius: '12px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
              maxWidth: '520px',
              width: '90%',
              border: '1px solid #e0e0e0',
            }}
          >
            <div style={{ marginBottom: '2rem' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  marginBottom: '1.25rem',
                }}
              >
                <h2
                  style={{
                    color: '#D32F2F',
                    margin: 0,
                    fontSize: '1.25rem',
                    // fontWeight: '600',
                  }}
                >
                  Remove Benchmark?
                </h2>
              </div>

              <div
                style={{
                  backgroundColor: '#fff3e0',
                  border: '1px solid #ffcc02',
                  borderRadius: '6px',
                  padding: '1rem',
                  marginBottom: '1rem',
                }}
              >
                <p
                  style={{
                    color: '#e65100',
                    // lineHeight: '1.5',
                    margin: 0,
                    fontSize: '0.95rem',
                    fontWeight: '500',
                  }}
                >
                  You're attempting to filter a <strong>non-benchmarkable dimension</strong>. This will remove your
                  active benchmark comparison.
                </p>
              </div>

              <p
                style={{
                  color: '#666',
                  fontSize: '0.9rem',
                  margin: 0,
                  lineHeight: '1.4',
                }}
              >
                Do you want to continue and remove the benchmark to add this filter?
              </p>
            </div>

            <div
              style={{
                display: 'flex',
                gap: '0.75rem',
                justifyContent: 'flex-end',
              }}
            >
              <button className="fBTN" type="button" onClick={handleBenchmarkRemovalCancelled}>
                Cancel
              </button>
              <DarkButton type="button" onClick={handleBenchmarkRemovalConfirmed}>
                Remove Benchmark & Add Filter
              </DarkButton>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PreviewModal;
